import React, { memo } from 'react';
import styles from './index.module.less';
import loadingImg from '@/assets/images/gameDetail/loading.webp';
import classnames from 'classnames';

interface LoadingProps {
  visible?: boolean;
}

function Loading(props: LoadingProps) {
  const { visible } = props;
  return (
    <div className={classnames(styles.loading, { [styles.background]: visible })}>
      <img src={loadingImg} alt="" />
    </div>
  );
}
export default memo(Loading);
